module.exports = __webpack_public_path__ + "static/media/daniela.b1c3c13b.svg";